import { useContext } from 'react';

import type { ContextType } from './PricingContext';
import { PricingContext } from './PricingContext';

export const usePricingContext = () => {
  const context = useContext<ContextType | undefined>(PricingContext);
  if (context === undefined) {
    throw new Error('usePricingContext must be used within a PricingProvider');
  }
  return context;
};
